import React, { useEffect, useState } from "react";
import { IUserComponentProps } from "./IUserComponentProps";
import "./UserComponent.scss";
import miscUtils from "../../utils/miscUtils";
import Moment from "react-moment";
import ReadMore from "../../utils/readMore/readMore";
import PrivilegeBadge from "./privilegeBadge";
import { RoleIds } from "containers/teamsContainer/domain";
import useWindowSize from "utils/windowSize";
import { Link, withRouter } from 'react-router-dom';

import clsx from "clsx";
import { connect } from "react-redux";
import { Map } from "immutable";
import MiniProfile from "./MiniProfile";
import { useAtom } from "jotai";
import { activeMemberIDAtom, memberDetailsProfilePopupAtom, showMessagePopUpAtom } from "showMessageMenuAtom";
import { getCookieValue } from "utils/cookieStorage";

const MOBILE_WINDOW_WIDTH: number = 550;

const UserComponent: React.FC<IUserComponentProps> = props => {
  const { timeStamp, job_title, about, hideName, showOnlineStatus, user, imageSize = "sm", showProfileSlider = true, group } = props;
  const containerStyles = props.containerStyles ? props.containerStyles : {};

  const windowSize = useWindowSize();

  const [canShowSlider, setCanShowSlider] = useState<boolean>(false);
  const [profileImageSize, setProfileImageSize] = useState<{ height: string; width: string }>();
  const [miniProfile, setShowMiniProfile] = useState(false)

  const ProfileImage = user && user.profile_image
  const nonCommunityMember = !props.group || !miscUtils.isActiveCommunityMember(props.group && props.group.user_membership)

  const determinePrivilege = () => {
    if (props.roleLabel) {
      return props.roleLabel
    } else if (user && user.user_role_label) {
      return user.user_role_label
    } else if (user && user.role_label && user.role_label.label) {
      return user.role_label.label.name
    }
    else {
      switch (props.roleId) {
        case RoleIds.Owner:
          return "Owner";
        case RoleIds.Admin:
          return "Admin";
        case RoleIds.Moderator:
          return "Moderator";
        default:
          return "Member";
      }
    }
  }

  const [, setActiveMemberID] = useAtom(activeMemberIDAtom);
  const [, setOpenmemberDetailsProfilePopup] = useAtom(memberDetailsProfilePopupAtom);

  const openPeopleDialog = () => {
    setOpenmemberDetailsProfilePopup(true)
  }

  const memberID = user && user.id || props.userMembership && props.userMembership.id

  const openProfileSlider = () => {
    if (!miscUtils.isGroupMember(group && group)) return
    if (props.eventGuest) return
    setActiveMemberID(memberID)
    openPeopleDialog()
  }

  const AnalyticsPage = window.location.pathname === '/settings/analytics'

  const [openMessagePopUp,] = useAtom(showMessagePopUpAtom);

  useEffect(() => {
    if (props.isAuthed && miscUtils.isGroupMember(group && group)) {
      if (openMessagePopUp || ((getCookieValue("user") && getCookieValue("user")['uuid']) === (user && user.uuid))) {
        return
      }
    }
  }, [group && group.id]);

  useEffect(() => {
    if (imageSize) {
      switch (imageSize) {
        case "sm":
          setProfileImageSize({ height: "35px", width: "35px" });
          break;

        case "md":
          setProfileImageSize({ height: "48px", width: "48px" });
          break;
      }
    }
  }, [imageSize])

  useEffect(() => {
    if (
      showProfileSlider &&
      props.isAuthed &&
      (user && user.id || props.userMembership && props.userMembership.id) && miscUtils.isGroupMember(group && group)) {
      setCanShowSlider(true);
    } else {
      setCanShowSlider(false);
    }
  }, [props.userMembership, showProfileSlider, group, props.isAuthed])

  const OpenMiniProfile = () => {
    setShowMiniProfile(true)
  }

  const settingsPage = window.location.pathname.includes('/settings')
  const articlePostPage = window.location.pathname.includes('/library/articles/lectures/view')
  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }

  return props.user && props.user.full_name && props.user.full_name.replace(/\s/g, '').length > 0 ? (
    <div className={clsx(
      "user-component",
      { ["sliderble"]: (canShowSlider || props.onClick) && !props.eventGuest }
    )}
      onClick={() => {
        if (!showProfileSlider || props.disabled) {
          return
        }
        if (!props.isPlacedonIntendedComp) {
          openProfileSlider();
          props.onClick && props.onClick();
        }
      }}
      style={{
        ...containerStyles,
        alignItems: settingsPage ? 'center' : 'flexStart'
      }}
    >
      {showOnlineStatus && (
        <span className={`status ${user.online_status === "active" ? "active" : "inactive"}`}></span>
      )}

      <div
        className="profile-image-container"
        onMouseEnter={() => {
          !AnalyticsPage && OpenMiniProfile()
        }}
        onMouseLeave={() => setShowMiniProfile(false)}
      >
        {(props.user.profile_image && isValidImage) ? (
          <img
            alt='user profile'
            className={`profile-image ${window.location.pathname.split("/").includes("messages") && "bg"}  ${(AnalyticsPage || props.eventGuest) && 'no-cursor'}`}
            src={props.user.profile_image}
            style={profileImageSize && { height: profileImageSize.height, width: profileImageSize.width, minHeight: profileImageSize.height, minWidth: profileImageSize.width }}
            onClick={() => {
              !AnalyticsPage && OpenMiniProfile()
            }}
            onError={onImageError}
          />
        ) : (
          <div
              className={`profile-image ${props.adminPeoplePage ? 'profile-image--profile-slideout' : ''} ${(AnalyticsPage || props.eventGuest) && 'no-cursor'}`}
            data-color={miscUtils.getColorInitial(`${props.user.full_name}`)}
              onClick={() => {
                !AnalyticsPage && OpenMiniProfile()
              }}
          >
            {miscUtils.getNameInitials(props.user.full_name)}
          </div>
        )}
        {
          !props.isAnnouncementPost &&
          props.isPlacedonIntendedComp &&
          !window.location.pathname.includes('/about') &&
          !props.eventGuest &&
          miniProfile &&
          <MiniProfile
            fullName={user && user.full_name}
            nonCommunityMember={nonCommunityMember}
            setShowMiniProfile={setShowMiniProfile}
            ProfileImage={ProfileImage}
            determinePrivilege={determinePrivilege}
            openProfileSlider={openProfileSlider}
          />
        }
      </div>

      <div className="info">
        <div
          className={`info-name ${(props.roleId === RoleIds.Owner || props.roleId === RoleIds.Admin || props.roleId === RoleIds.Moderator) && (windowSize.width <= MOBILE_WINDOW_WIDTH) ? 'info-name-badged' : ''}`}
        >
          {
            !hideName &&
            <p
                className={`name ${props.eventGuest ? 'no-hover' : ''} ${props.adminPeoplePage ? 'highlightable-user-name' : ''} ${props.postView ? 'postview-user-name' : ''} ${props.minimizableName ? 'minimizable-user-name' : ''}`}
              style={props.nameStyles ? { ...props.nameStyles } : {}}
                onClick={() => {
                  AnalyticsPage ? openProfileSlider() : setShowMiniProfile(true)
                }}
            >
              {props.user.full_name}
            </p>
          }

          {
            (props.roleId === RoleIds.Owner ||
              props.roleId === RoleIds.Admin ||
              props.roleId === RoleIds.Moderator ||
              props.roleId === RoleIds.Member
            ) &&
            !props.isCommentComponent
            &&
            <>
              <PrivilegeBadge
                privilege={determinePrivilege()}
                notGroupMember={nonCommunityMember}
              />
            </>
          }

          {
            window.innerWidth > 767 &&
                    <>
                    {timeStamp && <div className="period"></div>}

                    {timeStamp && (
                      props.onClickTimestamp ? (
                        <Link
                          to={props.onClickTimestamp}
                        >
                          <div
                            className={`timestamp 
                            ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                            ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                            `}
                          >
                            <Moment utc={true} fromNow ago>
                              {timeStamp}
                            </Moment>
                            <span>ago</span>
                          </div>
                        </Link>
                      ) : (
                        <div
                            className={`timestamp 
                          ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                          ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                          `}
                        >
                          <Moment utc={true} fromNow ago>
                            {timeStamp}
                          </Moment>
                          <span>ago</span>
                        </div>
                      )
                    )}
                    </>
          }
        </div>

        <div className="headline-period-time">
        {(!hideName && !settingsPage) &&props.user.headline &&
          (
            <div className="headline">
              <span
                className='headline-text'
              >
                {props.user.headline && props.user.headline}
              </span>
            </div>
          )
        }
          {
            window.innerWidth < 768 &&
                    <>
                    {props.user.headline && timeStamp && !settingsPage&& <div className="period-mobile"></div>}

                    {timeStamp && (
                      props.onClickTimestamp ? (
                        <Link
                          to={props.onClickTimestamp}
                        >
                          <div
                            className={`timestamp 
                            ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                            ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                            `}
                          >
                            <Moment utc={true} fromNow ago>
                              {timeStamp}
                            </Moment>
                            <span>ago</span>
                          </div>
                        </Link>
                      ) : (
                        <div
                            className={`timestamp 
                          ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                          ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                          `}
                        >
                          <Moment utc={true} fromNow ago>
                            {timeStamp}
                          </Moment>
                          <span>ago</span>
                        </div>
                      )
                    )}
                    </>
          }
        </div>

        {props.extraMarkup && props.extraMarkup}
        {job_title && <div className="job-title">{job_title}</div>}
        {about && (
          <div className="about">
            {about.length <= 280 && about}
            {about.length > 280 && (
              <ReadMore
                numberOfLines={1}
                lineHeight={1}
                showLessButton={true}
                text={about}
              />
            )}
          </div>
        )}
        {props.subText && (
          <div className="subtext-container">
            <p className="subtext-text">{props.subText}</p>
          </div>
        )}
      </div>
    </div>
  ) :
    <div className={clsx(
      "user-component",
      { ["sliderble"]: (canShowSlider || props.onClick) && !props.eventGuest }
    )}
      onClick={() => {
        if (!showProfileSlider) {
          return
        }
        if (!props.isPlacedonIntendedComp) {
          openProfileSlider();
          props.onClick && props.onClick();
        }
      }}
      style={{
        ...containerStyles,
        alignItems: settingsPage ? 'center' : 'flexStart'
      }}
    >
      {showOnlineStatus && (
        <span className={`status ${user.online_status === "active" ? "active" : "inactive"}`}></span>
      )}

      <div
        className="profile-image-container"
        onMouseEnter={() => {
          !AnalyticsPage && OpenMiniProfile()
        }}
        onMouseLeave={() => setShowMiniProfile(false)}
      >
        {(props.user && props.user.profile_image && isValidImage) ? (
          <img
            alt='user profile'
            className={`profile-image ${window.location.pathname.split("/").includes("messages") && "bg"}  ${(AnalyticsPage || props.eventGuest) && 'no-cursor'}`}
            src={props.user.profile_image}
            style={profileImageSize && { height: profileImageSize.height, width: profileImageSize.width, minHeight: profileImageSize.height, minWidth: profileImageSize.width }}
            onClick={() => {
              !AnalyticsPage && OpenMiniProfile()
            }}
            onError={onImageError}
          />
        ) : (
          <>
            {
              props.user && props.user.full_name ?
                <div
                  className={`profile-image ${props.adminPeoplePage ? 'profile-image--profile-slideout' : ''} ${(AnalyticsPage || props.eventGuest) && 'no-cursor'}`}
                  data-color={miscUtils.getColorInitial(`${props.user.full_name}`)}
                  onClick={() => {
                    !AnalyticsPage && OpenMiniProfile()
                  }}
                >
                  {miscUtils.getNameInitials(props.user.full_name)}
                </div>
                :
                <div
                  className={`profile-image ${props.adminPeoplePage ? 'profile-image--profile-slideout' : ''} ${(AnalyticsPage || props.eventGuest) && 'no-cursor'}`}
                    data-color={miscUtils.getColorInitial('No name')}
                  onClick={() => {
                    !AnalyticsPage && OpenMiniProfile()
                  }}
                >
                    {miscUtils.getNameInitials('No name')}
                </div>
            }
          </>
        )}
        {
          !props.isAnnouncementPost &&
          props.isPlacedonIntendedComp &&
          !window.location.pathname.includes('about') &&
          !props.eventGuest &&
          miniProfile &&
          <MiniProfile
            fullName={user && user.full_name}
            nonCommunityMember={nonCommunityMember}
            setShowMiniProfile={setShowMiniProfile}
            ProfileImage={ProfileImage}
            determinePrivilege={determinePrivilege}
            openProfileSlider={openProfileSlider}
          />
        }
      </div>

      <div className="info">
        <div
          className={`info-name ${(props.roleId === RoleIds.Owner || props.roleId === RoleIds.Admin || props.roleId === RoleIds.Moderator) && (windowSize.width <= MOBILE_WINDOW_WIDTH) ? 'info-name-badged' : ''}`}
        >
          {
            !hideName &&
            <>
              {
                props.user.full_name !== null ?
                  <p
                    className={`name ${props.eventGuest ? 'no-hover' : ''} ${props.adminPeoplePage ? 'highlightable-user-name' : ''} ${props.postView ? 'postview-user-name' : ''} ${props.minimizableName ? 'minimizable-user-name' : ''}`}
                    style={props.nameStyles ? { ...props.nameStyles } : {}}
                    onClick={() => {
                      AnalyticsPage ? openProfileSlider() : setShowMiniProfile(true)
                    }}
                  >
                    {props.user.full_name}
                  </p>
                  :
                  <p
                    className={`name ${props.eventGuest ? 'no-hover' : ''} ${props.adminPeoplePage ? 'highlightable-user-name' : ''} ${props.postView ? 'postview-user-name' : ''} ${props.minimizableName ? 'minimizable-user-name' : ''}`}
                    style={props.nameStyles ? { ...props.nameStyles } : {}}
                    onClick={() => {
                      AnalyticsPage ? openProfileSlider() : setShowMiniProfile(true)
                    }}
                  >
                    No name
                  </p>
              }
            </>
          }

          {
            (props.roleId === RoleIds.Owner ||
              props.roleId === RoleIds.Admin ||
              props.roleId === RoleIds.Moderator ||
              props.roleId === RoleIds.Member
            ) &&
            !props.isCommentComponent
            &&
            <>
              <PrivilegeBadge
                privilege={determinePrivilege()}
                notGroupMember={nonCommunityMember}
              />
            </>
          }

          {
             window.innerWidth > 767 &&
            <>
          {timeStamp && <div className="period"></div>}

          {timeStamp && (
            props.onClickTimestamp ? (
              <Link
                to={props.onClickTimestamp}
              >
                <div
                  className={`timestamp 
                ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                `}
                >
                  <Moment utc={true} fromNow ago>
                    {timeStamp}
                  </Moment>
                  <span>ago</span>
                </div>
              </Link>
            ) : (
              <div
                className={`timestamp 
              ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
              ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
              `}
              >
                <Moment utc={true} fromNow ago>
                  {timeStamp}
                </Moment>
                <span>ago</span>
              </div>
            )
          )}
          </>
          }
        </div>

        <div className="headline-period-time">

        {(!hideName && !settingsPage) &&
          (
            <div className="headline">
              <span
                className='headline-text'
              >
                {props.user.headline && props.user.headline}
              </span>
            </div>
          )
        }

          {
            window.innerWidth < 768 &&
                    <>
                    {props.user.headline && timeStamp && !settingsPage&& <div className="period-mobile"></div>}

                    {timeStamp && (
                      props.onClickTimestamp ? (
                        <Link
                          to={props.onClickTimestamp}
                        >
                          <div
                            className={`timestamp 
                            ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                            ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                            `}
                          >
                            <Moment utc={true} fromNow ago>
                              {timeStamp}
                            </Moment>
                            <span>ago</span>
                          </div>
                        </Link>
                      ) : (
                        <div
                            className={`timestamp 
                          ${props.postView && !props.messagingView && !articlePostPage ? "timestamp--postview" : ""}
                          ${articlePostPage || props.isAnnouncementPost ? 'non-clickable-timeStamp' : ""}
                          `}
                        >
                          <Moment utc={true} fromNow ago>
                            {timeStamp}
                          </Moment>
                          <span>ago</span>
                        </div>
                      )
                    )}
                    </>
          }
        </div>

        {props.extraMarkup && props.extraMarkup}
        {job_title && <div className="job-title">{job_title}</div>}
        {about && (
          <div className="about">
            {about.length <= 280 && about}
            {about.length > 280 && (
              <ReadMore
                numberOfLines={1}
                lineHeight={1}
                showLessButton={true}
                text={about}
              />
            )}
          </div>
        )}
        {props.subText && (
          <div className="subtext-container">
            <p className="subtext-text">{props.subText}</p>
          </div>
        )}
      </div>
    </div>
    ;
};

const mapStateToProps = (state: Map<string, any>) => {
  const authorize = Map(state.get("authorize", {})).toJS() as any;
  const selectedGroup: any = state.getIn(["global", "selectedGroup"]);
  const global = Map(state.get("global", {})).toJS() as any;

  return {
    isAuthed: authorize.authed,
    authedUser: authorize.user,
    group: selectedGroup,
    global
  };
};

export default withRouter(
  connect(mapStateToProps, null)(UserComponent as any) as any
) as any;
